import { render, staticRenderFns } from "./SaveToShortlistModal.vue?vue&type=template&id=dc4f8f16"
import script from "./SaveToShortlistModal.vue?vue&type=script&lang=js"
export * from "./SaveToShortlistModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports